// extracted by mini-css-extract-plugin
module.exports = {"background":"trustedUsPromotePage_background__2WhHE","container":"trustedUsPromotePage_container__1fOrK","content":"trustedUsPromotePage_content__JDUwi","swiper":"trustedUsPromotePage_swiper__340zG","title":"trustedUsPromotePage_title__1uHYF","logo":"trustedUsPromotePage_logo__m48Ml"};
    if(module.hot) {
      // 1745223416003
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  